<p-panel [styleClass]="!isRbe4() ? 'pt-3 p-panel-slimheight' : 'pt-3'">
	<ng-template pTemplate="header">
		<div class="flex align-items-center">
			<span class="font-semibold">{{ 'STATE_OUTPUTS' | translate }}</span>
		</div>
	</ng-template>
	<ng-template *ngIf="!isRbe4()" pTemplate="icons">
		<p-button icon="pi cm-pencil" pTooltip="{{ 'EDIT' | translate }}" tooltipPosition="bottom" (click)="editAlias()"
			[text]="true" severity="secondary" [disabled]="!deviceConfigured || !device.CurrentlyOwned">
		</p-button>
	</ng-template>
	<div class="grid pt-1" *ngIf="!isRbe24230()">
		<div class="col-3 flex align-items-center justify-content-center gap-3" *ngFor="let o of outputArray; index as i">
			<p-tag [value]="i + 1" [severity]="o ? 'success' : 'danger'"></p-tag>
			<div>{{translateDataAlias(i + 1)}}</div>
		</div>
	</div>
	<div class="grid pt-1" *ngIf="isRbe24230()">
		<div class="col-3 flex align-items-center justify-content-center gap-3" *ngFor="let o of outputArray; index as i">
			<span>{{ i + 1 }}</span>
			<div>{{translateDataAlias(i + 1)}}</div>
			<p-tag [value]="stateLabel(i, o)" [severity]="o ? 'success' : 'danger'"></p-tag>
			<p-button icon="pi cm-pencil" pTooltip="{{ 'EDIT' | translate }}" tooltipPosition="bottom"
				(click)="editState(i)" [text]="true" severity="secondary"
				[disabled]="!deviceConfigured || !device.CurrentlyOwned">
			</p-button>
		</div>
	</div>
</p-panel>